import { render, staticRenderFns } from "./TisslSettings.vue?vue&type=template&id=a7f6578c"
import script from "./TisslSettings.vue?vue&type=script&lang=js"
export * from "./TisslSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports